import { createReducer } from 'utils/ReduxUtils';

import * as actionTypes from '../../../../actionTypes';

const initialState = false;

const isUpdating = () => true;
const isEnding = () => false;

export default createReducer(initialState, {
  [actionTypes.CREATE]: isUpdating,
  [actionTypes.CREATE_SUCCESS]: isEnding,
  [actionTypes.CREATE_FAILURE]: isEnding,
  [actionTypes.UPDATE]: isUpdating,
  [actionTypes.UPDATE_SUCCESS]: isEnding,
  [actionTypes.UPDATE_FAILURE]: isEnding,
});
